import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { decrypt } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { palletReusableOpts, ReuseList } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-import-project-pallet-configuration',
  templateUrl: './import-project-pallet-configuration.component.html',
  styleUrls: ['./import-project-pallet-configuration.component.scss'],
})
export class ImportProjectPalletConfigurationComponent {
  palletList: any;
  scenarioId: any;
  palletTypeId: any;
  selectedReuses: any;
  palletConfigurationId: any;
  selectedPalletType: any;
  selectedReusability: any;
  palletAddEditForm!: FormGroup;
  submitted: boolean = false;
  @Output() savePalletView = new EventEmitter<any>();
  isPalletReusable = palletReusableOpts;
  reuseList = ReuseList;
  disableNoOfReuses!: boolean;

  constructor(
    private modal: CustomModalService,
    private route: ActivatedRoute,
    private projectsService: ProjectsService,
    private formBuilder: FormBuilder
  ) {
    this.palletList = this.modal?.modalService?.config?.initialState?.['palletData'];
    this.palletConfigurationId =
      this.modal?.modalService?.config?.initialState?.['palletConfigurationId'];

    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
    });
    this.getPallet();
  }

  ngOnInit() {
    this.palletAddEditForm = this.formBuilder.group({
      palletType: [null, Validators.required],
      palletReusable: [null, Validators.required],
      totalPalletReuses: [null, Validators.required],
    });
    this.setFormValue();
  }

  setFormValue() {
    if (this.palletList.id == 0) {
      this.selectedReusability = this.palletList.palletReusable ? 'Yes' : 'No';
      this.disableNoOfReuses = this.selectedReusability == 'No';
      this.reuseList = !this.disableNoOfReuses
        ? this.reuseList.filter((x: any) => x.reuseable)
        : this.reuseList;
      this.palletAddEditForm.patchValue({
        palletType: this.selectedPalletType,
        palletReusable: this.selectedReusability,
        totalPalletReuses: this.palletList?.palletReuse,
      });
    }
  }

  onClose() {
    this.modal.close();
  }

  savePallet(fromCancel?: any) {
    if (fromCancel && this.palletList.modifiedBy) return this.modal.close();
    if (fromCancel) {
      this.palletTypeId = this.palletList?.palletTypeId; // Default Id for Ignore Pallet Manufacturer
      this.palletAddEditForm.controls['palletReusable'].setValue(
        this.palletList.palletReusable ? 'Yes' : 'No'
      );
      this.selectedReuses = this.palletList?.palletReuse;
    }
    this.submitted = true;
    if (this.palletAddEditForm.valid) {
      const payload = {
        Id: this.palletConfigurationId || 0,
        scenarioId: Number(this.scenarioId),
        palletTypeId: this.palletTypeId || this.palletList?.palletTypeId,
        palletReusable:
          (this.palletAddEditForm.controls['palletReusable'].value?.name ||
            this.palletAddEditForm.controls['palletReusable']?.value) == 'Yes'
            ? true
            : false,
        palletReuse:
          (this.palletAddEditForm.controls['palletReusable'].value?.name ||
            this.palletAddEditForm.controls['palletReusable']?.value) == 'No'
            ? '0 reuse'
            : this.selectedReuses || this.palletList?.palletReuse,
      };
      this.savePalletView.emit(payload);
    }
  }

  selectedPallet(event: any) {
    if (event?.id) {
      this.palletTypeId = event?.id;
    }
  }

  isReusable(event: any) {
    if (event?.name) {
      this.disableNoOfReuses = event.name == 'No';
      if (this.disableNoOfReuses) {
        this.reuseList = ReuseList;
        this.palletAddEditForm.controls['totalPalletReuses'].setValue(this.reuseList[0]);
        this.selectedReuses = '0 reuse';
      } else {
        this.reuseList = this.reuseList.filter((x: any) => x.reuseable);
        this.palletAddEditForm.controls['totalPalletReuses'].setValue(this.reuseList[0]);
        this.selectedReuses = '1 reuse';
      }
    }
  }

  totalReuses(event: any) {
    if (event.name) {
      this.selectedReuses = event.name;
    }
  }

  async getPallet() {
    await this.palletList?.palletType?.map((item: any) => {
      if (item.id == this.palletList?.palletTypeId) {
        return (this.selectedPalletType = item);
      }
    });
  }
}
